// Text rules for names and titles, in a module of its own: the client's first chunk (ui.ts, room arrival) needs
// cleanText, and importing it from validate.ts would move all of validate.ts out of the lazy multiplayer chunk.

// Control characters (C0, DEL, C1) and bidi overrides are not allowed in names and ids.
export const CONTROL_RE = /[\u0000-\u001f\u007f-\u009f‪-‮⁦-⁩]/;

const CONTROL_RE_G = new RegExp(CONTROL_RE.source, "g");
/** `s` without lone UTF-16 surrogates (half of a pair: encodeURIComponent throws on one). No regex lookbehind: Safari
 *  before 16.4 cannot parse it. */
function dropLoneSurrogates(s: string): string {
  let out = "";
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    if (c >= 0xd800 && c <= 0xdbff) {
      const d = s.charCodeAt(i + 1);
      if (d >= 0xdc00 && d <= 0xdfff) { out += s.slice(i, i + 2); i++; }
    } else if (c < 0xdc00 || c > 0xdfff) {
      out += s[i];
    }
  }
  return out;
}

/**
 * `v` made acceptable for a name or a title (clients, before sending): the characters normalizeName / normalizeTitle
 * reject removed, trimmed, cut to `max` UTF-16 units without leaving half a surrogate pair. "" when nothing is left.
 */
export function cleanText(v: string, max: number): string {
  return dropLoneSurrogates(v.replace(CONTROL_RE_G, "").trim().slice(0, max)).trim();
}
